module.exports = __webpack_public_path__ + "img/our1.144d9909.png";